// extracted by mini-css-extract-plugin
export default {"container":"container_cTMkv","title":"title_VUxRz","texts":"texts_GeUUs","textSmall":"textSmall_pqEVK"};